/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Answer_Feedback_Error_Comment_Too_LongInputs */

const es_co2_answer_feedback_error_comment_too_long = /** @type {(inputs: Answer_Feedback_Error_Comment_Too_LongInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`El comentario debe tener máximo ${i?.count} caracteres.`)
};

/**

* @param {Answer_Feedback_Error_Comment_Too_LongInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const answer_feedback_error_comment_too_long = /** @type {((inputs: Answer_Feedback_Error_Comment_Too_LongInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Answer_Feedback_Error_Comment_Too_LongInputs, { locale?: "es-CO" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_answer_feedback_error_comment_too_long(inputs)
});